import axios from "@/http/HttpAxios";

// 获取商品卡片列表（支持分页）
export let getProductCardList = (currentPage = 1, pageSize = 12)=>  axios.get(`/product/list?current=${currentPage}&size=${pageSize}`);

// 获取商品详情
export let getProductDetail = (productId)=>  axios.get(`/product/${productId}`);

// 根据关键词搜索商品
export let searchProducts = (keyword, currentPage = 1, pageSize = 12)=>  axios.get(`/product/list?current=${currentPage}&size=${pageSize}&keyword=${keyword}`);

// 根据分类ID获取商品（支持搜索和排序）
export let getProductsByCategory = (categoryId, currentPage = 1, pageSize = 12, keyword = '', sortField = '', sortOrder = '') => {
  let url = `/product/category/${categoryId}?current=${currentPage}&size=${pageSize}`;
  if (keyword) url += `&keyword=${keyword}`;
  if (sortField) url += `&sortField=${sortField}`;
  if (sortOrder) url += `&sortOrder=${sortOrder}`;
  return axios.get(url);
};

// 根据分类ID和关键词搜索商品 (已合并到 getProductsByCategory，保留旧接口兼容)
export let searchProductsByCategory = (categoryId, keyword, currentPage = 1, pageSize = 12) => getProductsByCategory(categoryId, currentPage, pageSize, keyword);

// 根据排序字段获取商品
export let getProductsBySort = (sortField, sortOrder, currentPage = 1, pageSize = 12)=>  axios.get(`/product/list?current=${currentPage}&size=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}`);

// 分类相关API
// 获取所有分类
export let getAllCategories = ()=>  axios.get(`/category/all`);

// 获取一级分类
export let getFirstLevelCategories = ()=>  axios.get(`/category/level1`);

// 根据父分类ID获取子分类
export let getSubCategoriesByParentId = (parentId)=>  axios.get(`/category/sub/${parentId}`);

// 根据ID获取分类详情
export let getCategoryById = (id)=>  axios.get(`/category/${id}`);

// 购物车相关API
// 添加商品到购物车
export let addToCart = (cartDTO)=>  axios.post(`/cart/add`, cartDTO);

// 获取用户购物车商品
export let getCartByUserId = (userId)=>  axios.get(`/cart/user/${userId}`);

// 更新购物车商品数量
export let updateCartQuantity = (cartId, userId, quantity)=>  axios.put(`/cart/quantity?cartId=${cartId}&userId=${userId}&quantity=${quantity}`);

// 删除购物车商品
export let deleteCart = (cartId, userId)=>  axios.delete(`/cart/${cartId}?userId=${userId}`);

// 更新购物车商品选中状态
export let updateCartSelectedStatus = (cartId, userId, isSelected)=>  axios.put(`/cart/selected?cartId=${cartId}&userId=${userId}&isSelected=${isSelected}`);

// 清空购物车
export let clearCart = (userId)=>  axios.delete(`/cart/clear/${userId}`);

